import React, { FC } from 'react';
import {render} from 'react-dom';
import { getJwtToken, clearJwtToken } from "./Utils/LoginUtil"
import { setAuthtoken, setCurrentBusiness } from "./Services/api/fetch";

const rootEle = document.getElementById('root');

function getBusinessFromCookie(): string | null {
    const match = document.cookie.match(/(?:^|;\s*)currentselectedbusiness=([^;]+)/);
    return match ? match[1] : null;
}

export async function goToLogin() {
    setAuthtoken("");
    clearJwtToken();
    let mApp: Promise<{App:FC<{}>}>;
    mApp = import("./Components/App/App") as any;
    const {App} = await mApp;
    render(<App />, rootEle);
}

export async function bootstrap() {
	const jwtToken = getJwtToken();
    const currentPath = document.location.pathname;
    
    // Allow anonymous access to these routes
    const anonymousRoutes = ["/signIn", "/cong-no"];
    const isAnonymousRoute = anonymousRoutes.some(route => currentPath.startsWith(route));
    
    if (isAnonymousRoute) {
        if (currentPath === "/signIn") {
            goToLogin();
            return;
        }
        // For other anonymous routes, just load the app without auth
        let mApp: Promise<{App:FC<{}>}>;
        mApp = import("./Components/App/App") as any;
        const {App} = await mApp;
        render(<App />, rootEle);
        return;
    }
    
    if (!jwtToken) {
        document.location.pathname = "/signIn";
        goToLogin();
        return
    }

    setAuthtoken(jwtToken);

    const businessId = getBusinessFromCookie();
    if (businessId) {
        setCurrentBusiness(businessId);
    }

    let mApp: Promise<{App:FC<{}>}>;
    mApp = import("./Components/App/App") as any;
    const {App} = await mApp;
    render(<App />, rootEle);
}

bootstrap();